import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { Sparkles } from 'lucide-react'
import type { Insights } from '../hooks/useInsights'

interface TopClickedProductsProps {
  products: Insights['topClickedProducts'] | undefined
  isLoading: boolean
}

export function TopClickedProducts({ products, isLoading }: TopClickedProductsProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Sparkles className="h-5 w-5" />
          Top Clicked Products
        </CardTitle>
        <CardDescription>Products customers actually clicked from search results</CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-2">
            {[1, 2, 3, 4, 5].map((i) => (
              <Skeleton key={i} className="h-12 w-full" />
            ))}
          </div>
        ) : !products || products.length === 0 ? (
          <div className="flex h-32 items-center justify-center text-sm text-muted-foreground">
            No click data yet
          </div>
        ) : (
          <div className="space-y-1.5">
            {products.map((p, idx) => (
              <div
                key={p.productId}
                className="flex items-center gap-3 rounded-lg border bg-card p-2"
              >
                <span className="w-5 text-center text-sm text-muted-foreground">{idx + 1}</span>
                {p.imageUrl ? (
                  <img
                    src={p.imageUrl}
                    alt=""
                    className="h-10 w-10 rounded object-cover"
                    loading="lazy"
                  />
                ) : (
                  <div className="h-10 w-10 rounded bg-muted" />
                )}
                <div className="min-w-0 flex-1">
                  <div className="truncate text-sm font-medium">{p.title}</div>
                  {p.brand && (
                    <div className="text-xs text-muted-foreground">{p.brand}</div>
                  )}
                </div>
                <span className="text-sm font-semibold tabular-nums">{p.clicks}</span>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
